import { createSelector } from "reselect";
import getProject from "./get_project";

const getProjectName = createSelector([
  getProject
], (project) => project?.name || null);

export default getProjectName;
